import { Item, SolarCalcPage } from '../../../NewVersion/components/solar-calculator';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EFChecked from '@/components/UI/svg/blade/calculator/EFChecked';
import NextImage from '@/components/NextImage';

export default function Step1({ calObj, callBack }: any) {
    const { useLang, useState, gtm, useRouter } = useGlobal();
    const { t } = useLang('calculatorssolarpanels');
    const { locale } = useRouter();
    const [checked, setChecked] = useState(calObj?.check1 ?? '');
    const items: Item[] = [
        {
            webp: 'https://websiteoss.ecoflow.com/upload/image/1749092134977/Outdoors.jpg',
            img: 'https://websiteoss.ecoflow.com/upload/image/1749092134977/Outdoors.jpg',
            text: t('step1_text1'),
            key: 'outdoor',
        },
        {
            webp: 'https://websiteoss.ecoflow.com/upload/image/1749092134799/Home.jpg',
            img: 'https://websiteoss.ecoflow.com/upload/image/1749092134799/Home.jpg',
            text: t('step1_text2'),
            key: 'home',
        },
        {
            webp: 'https://websiteoss.ecoflow.com/upload/image/1749092135243/Professional%20Work.jpg',
            img: 'https://websiteoss.ecoflow.com/upload/image/1749092135243/Professional%20Work.jpg',
            text: t('step1_text3'),
            key: 'work',
        },
        {
            webp: 'https://websiteoss.ecoflow.com/upload/image/1749092135438/Others.jpg',
            img: 'https://websiteoss.ecoflow.com/upload/image/1749092135438/Others.jpg',
            text: t('step1_text4'),
            key: 'others',
        },
    ];
    const handleCheck = (key: string) => {
        setChecked(key === checked ? '' : key);
        callBack({ ...calObj, currentStep: key === checked ? 0 : 1, check1: key === checked ? '' : key });
    };
    const handleNext = () => {
        callBack({ ...calObj, currentPage: SolarCalcPage.Step2 }, true);
        gtm.push({
            event: 'uaEvent',
            event_name: 'checklist_process1',
            step: 'Scenario_1',
            product_name: 'EcoFlow Solar Panel',
            button_name: 'Next',
            option_name: items?.find((item: Item) => item.key === checked)?.text,
        });
    };
    return (
        <div className={`step1 ${css.step1}`}>
            <p className="step1-title title">{t('step1_title')}</p>
            <ul className="step1-box">
                {items?.map((item: any, k: number) => (
                    <li className="step1-item" key={item?.text} onClick={() => handleCheck(item?.key)}>
                        <div className="img-box">
                            <NextImage webpSrc={item?.webp || item?.img} src={item?.img} alt={item.text} aria-label={item.text} />
                            {checked === item?.key && (
                                <>
                                    <div className="mask"></div>
                                    <EFChecked width=".3rem" height=".3rem" className="checked" />
                                </>
                            )}
                        </div>
                        <p className="img-text">{item?.text}</p>
                    </li>
                ))}
            </ul>
            <div className="fix-footer single">
                <button className="btn-next" disabled={!checked} onClick={handleNext}>
                    {t('common_next')}
                </button>
            </div>
        </div>
    );
}
